import { render, staticRenderFns } from "./VisitorMessageBox.vue?vue&type=template&id=75595613&scoped=true&"
import script from "./VisitorMessageBox.vue?vue&type=script&lang=js&"
export * from "./VisitorMessageBox.vue?vue&type=script&lang=js&"
import style0 from "./VisitorMessageBox.vue?vue&type=style&index=0&id=75595613&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75595613",
  null
  
)

export default component.exports